import React, { useState } from 'react';
import { Login } from '../Authentication/Login';
import { useThemeContext } from '../../context';

export interface ServiceAuthProps {
  serviceName?: string;
  onLogin: (e?: any) => void;
}

export function ServiceAuth({
  serviceName,
  onLogin,
}: ServiceAuthProps): JSX.Element {
  const [authenticating, setAuthenticating] = useState(false);

  const theme = useThemeContext();

  return (
    <Login
      loggingIn={authenticating}
      login={onLogin}
      render={({ LoginContainerDiv, LoginIntroduction, LoginButton }) => (
        <LoginContainerDiv themeStr={theme}>
          <LoginIntroduction />
          <LoginButton
            onClick={() => {
              onLogin();
              setAuthenticating(true);
            }}
            buttonText={
              authenticating ? 'Signing in...' : `Sign in to ${serviceName}`
            }
            disabled={authenticating}
          />
        </LoginContainerDiv>
      )}
    />
  );
}
